/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

/**
 * Method to execute callback basis keyboard events
 * @param  {object} payload
 *      payload = {
 *         {eventType}: [
 *                {function},   Callback to execute
 *                {boolean},    Whether to call stopPropagation
 *                {boolean}     Whether to call preventDefault
 *             ]
 *      }
 *      Supported Event Types:
 *         1. onEnter: Called when enter or space key is pressed
 *         2. onLeftArrow: Called when left arrow is pressed
 *         3. onRightArrow: Called when right arrow is pressed
 *
 * Usage: <Button tabIndex={0} onKeyDown={interpretKey({ onEnter: [onHelp, false, true] })}/>
 */
export function interpretKey(payload) {
    return (event) => {
        Object.keys(payload).forEach((key) => {
            const [callBack, stopPropagation, preventDefault] = payload[key] || [];
            switch (key) {
            case 'onEnter':
                if (event.key === 'Enter' || event.key === ' ') {
                    if (callBack && typeof callBack === 'function') {
                        callBack(event);
                    }
                    if (stopPropagation) {
                        event.stopPropagation();
                    }
                    if (preventDefault) {
                        event.preventDefault();
                    }
                }
                break;
            case 'onLeftArrow':
                if (event.key === 'ArrowLeft') {
                    if (callBack && typeof callBack === 'function') {
                        callBack(event);
                    }
                    if (stopPropagation) {
                        event.stopPropagation();
                    }
                    if (preventDefault) {
                        event.preventDefault();
                    }
                }
                break;
            case 'onRightArrow':
                if (event.key === 'ArrowRight') {
                    if (callBack && typeof callBack === 'function') {
                        callBack(event);
                    }
                    if (stopPropagation) {
                        event.stopPropagation();
                    }
                    if (preventDefault) {
                        event.preventDefault();
                    }
                }
                break;
            default:
            }
        });
    };
}
